// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gas-fees[data-v-0da77c08]{font-size:14px!important}.gas-fees .fee i[data-v-0da77c08],.gas-fees .fee p[data-v-0da77c08]{margin-bottom:6px}.gas-fees .secondary-text[data-v-0da77c08]{color:#9e9e9e}.gas-fees .control-icon[data-v-0da77c08]{transition:transform .5s ease}.gas-fees .control-icon.up[data-v-0da77c08]{transform:rotate(180deg)}", ""]);
// Exports
module.exports = exports;
